import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppLoadingService {
  private loaders: { [key: string]: boolean } = {};

  loading = signal(false);

  private updateLoading() {
    this.loading.set(Object.keys(this.loaders).length > 0);
  }

  add(key: string) {
    this.loaders[key] = true;
    this.updateLoading();
  }

  remove(key: string) {
    delete this.loaders[key];
    this.updateLoading();
  }
}
